import React, { PropsWithChildren } from 'react';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { commonAPI, persistor, setOrganisation, store } from '@/store';
import { OrganisationContext, OrganisationContextData } from '@/utils/context/OrganisationContext';

export const ReduxProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <OrganisationContext
          syncFn={(org: OrganisationContextData) => {
            store.dispatch(setOrganisation(org));
            store.dispatch(commonAPI.util.invalidateTags(['Customers', 'CustomerEnrolments', 'Sessions', 'Enrolment']));
          }}
        >
          {children}
        </OrganisationContext>
      </PersistGate>
    </Provider>
  );
};
